// extracted by mini-css-extract-plugin
export default {"SkeletonBlock":"SkeletonBlock_SkeletonBlock__30rXl","passby":"SkeletonBlock_passby__zkHJC"};